<template>
  <div>
    <DxDropDownButton
      :items="getItems"
      :keyExpr="'RecordID'"
      :displayExpr="'ReportDisplayName'"
      :drop-down-options="{ width: 200 }"
      class="gc-dropdown-icon-button"
      :icon="'print'"
      styling-mode="text"
      :show-arrow-icon="false"
      :onItemClick="onItemClick"
      v-if="getItems.length > 1"
    />
    <DxButton
      class="invoice-print-btn"
      icon="print"
      @click="onItemClick({ itemData: getItems[0] })"
      v-else
    />
  </div>
</template>
<script>
import { TransactionListService } from "../_services/api/templates/transactions-list.services";
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    dataField: {
      type: String,
      default: "Code",
    },
    refresh: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      printReports: undefined,
      validationSummaryVisible: false,
      validationItems: [],
    };
  },
  created() {
    // if (this.data.column.BackgroundPrint)
    //   this.printReports = this.data.column.BackgroundPrint;
    // else this.printReports = [];
  },
  computed: {
    getItems() {
      if (this.data.column.BackgroundPrint)
        if (this.data.column.menuItems)
          if (this.data.column.menuItems.makeDisabled)
            return this.data.column.menuItems.makeDisabled(this.data);
          else return this.data.column.BackgroundPrint;
        else return this.data.column.BackgroundPrint;
      else return [];
    },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    async onItemClick(data) {
      this.showLoading(true);

      var referenceNoField = undefined;
      if (this.data.column.ReferenceNoField)
        referenceNoField = this.data.column.ReferenceNoField;
      else if (this.data.column.ReferenceNoFields) {
        this.data.column.ReferenceNoFields.forEach((element) => {
          if (element.ReportDisplayName == data.itemData.ReportDisplayName) {
            referenceNoField = element.ReferenceNoField;
          }
        });
      }

      // ReferenceNo should be a String
      let referenceNo = "" + this.data.data[referenceNoField];

      TransactionListService.reportBackgroundPrintOrder({
        ReportName: data.itemData.ReportDisplayName,
        ScreenName: data.itemData.ScreenName,
        TransactionCode: data.itemData.TransactionCode,
        ReferenceNo: referenceNo,
      })
        .then((res) => {        

          if (res.data.ReloadRecords) this.refresh();
          this.showLoading(false);
        })
        .catch((err) => {
          if (err) this.showLoading(false);
          this.$store.dispatch("ui/setServerError", {
            error: err,
            title: "Failed",
          });
        });
    },
  },
};
</script>

<style lang="scss"></style>
